// extracted by mini-css-extract-plugin
export default {"days":"_1LlTuTF90pDMJ4JtFBpR0M","isActive":"_2blTamppEjRZVKChatKSR8","hours":"_30Nd-CUXIjSVoNKEjXN6_n"};